import React, { useEffect, useState } from "react";
import { DropdownField } from "../../../../../../components/inputs";
import { Flex, Form } from "antd";
import { useTranslation } from "react-i18next";
import {
  ErrorText,
  StyledForm,
  StyledModal,
} from "../../../../../../components/common/styles";
import { useAppDispatch, useAppSelector } from "../../../../../../store/config";
import { useParams } from "react-router-dom";
import { ITrainingProgramWithAccounts } from "../../../../../../interfaces/store/training-programs-interface";
import { copyWorkoutInTrainingProgramStart } from "../../../../../../store/features/training-program/training-program-slice";
import { ReactComponent as ErrorIcon } from "../../../../../../assets/icons/Error.svg";
import { fetchTrainingProgramsForWorkoutStart } from "../../../../../../store/features/workout/workout-slice";

export const DuplicateWorkoutModal = (props: {
  modalOpen: boolean;
  setModalOpen: (value: boolean) => void;
  error?: string;
  currentWorkoutId: string;
  timesPerWeek: number;
  setError: (value: string) => void;
}) => {
  const {
    modalOpen,
    setModalOpen,
    timesPerWeek,
    currentWorkoutId,
    error,
    setError,
  } = props;

  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { id: trainerId } = useParams<{ id: string }>();

  const [form] = Form.useForm();

  const { trainingPrograms } = useAppSelector((state) => state.workout);
  const [chosenTrainingProgram, setChosenTrainingProgram] =
    useState<null | ITrainingProgramWithAccounts>(null);

  useEffect(() => {
    if (!modalOpen) {
      form.resetFields();
    }
  }, [modalOpen]);

  useEffect(() => {
    dispatch(
      fetchTrainingProgramsForWorkoutStart({
        filter: { trainer: trainerId },
        sort: { sortBy: "updatedAt", sortOrder: -1 },
        search: "",
        pagination: {
          page: 0,
          limit: 1000,
          skip: 0,
        },
      })
    );
  }, [trainerId, dispatch]);

  const onFinish = (values: any) => {
    let index = undefined;
    if (values.week !== undefined && values.day !== undefined) {
      index =
        parseInt(values.week + "") * timesPerWeek + parseInt(values.day + "");
    }
    if (index !== undefined) {
      dispatch(
        copyWorkoutInTrainingProgramStart({
          trainingProgramId: values.trainingProgramId,
          index,
          workoutId: currentWorkoutId,
        })
      );
    }
  };

  const daysOptions = Array.from(
    { length: chosenTrainingProgram?.trainingProgram?.timesPerWeek || 0 },
    (_, i) => i + 1
  ).map((_, index) => ({
    label: ` ${index + 1}`,
    value: index + "",
  }));

  const weeksOptions = Array.from(
    { length: chosenTrainingProgram?.trainingProgram?.numberOfWeeks || 0 },
    (_, i) => i + 1
  ).map((_, index) => ({
    label: `${t("Week")} ${index + 1}`,
    value: index + "",
  }));

  const selectOptions = trainingPrograms.map((trainingProgram) => ({
    label: trainingProgram.trainingProgram.name || "",
    value: trainingProgram.trainingProgram._id || "",
  }));

  return (
    <StyledModal
      title={t("Duplicate Workout")}
      open={modalOpen}
      onOk={() => {
        form.submit();
      }}
      onCancel={() => {
        setModalOpen(false);
      }}
      centered
      okText={t("Duplicate")}
      cancelText={t("Cancel")}
      width={400}
      okButtonProps={{
        style: { color: "white" },
        disabled: !!error,
      }}
    >
      <StyledForm form={form} onFinish={onFinish} validateTrigger="onSubmit">
        <Flex gap={15} vertical style={{ marginTop: 20 }}>
          <DropdownField
            label={t("Duplicate workout to")}
            options={selectOptions}
            isEditable={true}
            rules={[{ required: true, message: t("Required") }]}
            onChange={(value) => {
              const selectedProgram = trainingPrograms.find(
                (program) => program.trainingProgram._id === value
              );
              setChosenTrainingProgram(selectedProgram || null);
              setError("");
            }}
            name="trainingProgramId"
          />
          <Flex gap={20}>
            <DropdownField
              label={t("Week")}
              options={weeksOptions}
              isEditable={true}
              name="week"
              rules={[{ required: true, message: t("Required") }]}
              onChange={() => setError("")}
            />
            <DropdownField
              label={t("Day")}
              options={daysOptions}
              isEditable={true}
              name="day"
              rules={[{ required: true, message: t("Required") }]}
              onChange={() => setError("")}
            />
          </Flex>
          {error && (
            <Flex align="center" gap={5} justify="center">
              <ErrorIcon />
              <ErrorText>{error}</ErrorText>
            </Flex>
          )}
        </Flex>
      </StyledForm>
    </StyledModal>
  );
};
